export const FACEBOOK_TOKEN_INVALID = 2000;
